import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OpenGraph = ({
  url,
  title,
  description,
  image,
  imageAlt,
  imageWidth,
  imageHeight
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [title && /*#__PURE__*/_jsx("meta", {
      content: title,
      property: "og:title"
    }), title && /*#__PURE__*/_jsx("meta", {
      content: title,
      property: "twitter:title"
    }), description && /*#__PURE__*/_jsx("meta", {
      content: description,
      property: "og:description"
    }), description && /*#__PURE__*/_jsx("meta", {
      content: description,
      property: "twitter:description"
    }), url && /*#__PURE__*/_jsx("meta", {
      content: url,
      property: "og:url"
    }), image && /*#__PURE__*/_jsx("meta", {
      content: image,
      property: "og:image"
    }), image && /*#__PURE__*/_jsx("meta", {
      content: image,
      property: "twitter:image"
    }), imageAlt && /*#__PURE__*/_jsx("meta", {
      content: imageAlt,
      property: "og:image:alt"
    }), imageAlt && /*#__PURE__*/_jsx("meta", {
      content: imageAlt,
      property: "twitter:image:alt"
    }), imageWidth && /*#__PURE__*/_jsx("meta", {
      content: imageWidth.toString(),
      property: "og:image:width"
    }), imageHeight && /*#__PURE__*/_jsx("meta", {
      content: imageHeight.toString(),
      property: "og:image:height"
    }), /*#__PURE__*/_jsx("meta", {
      content: "summary_large_image",
      name: "twitter:card"
    })]
  });
};
export default OpenGraph;